var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-content', {
    attrs: {
      "max-width": "1140"
    }
  }, [_c('v-row', {
    staticClass: "mt-3 mt-md-8 px-1",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "tit tit--lg",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("테마 설정")]), _c('v-spacer'), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "auto"
    }
  })], 1), _c('v-list-item-group', {
    staticClass: "mt-4"
  }, [_c('v-row', _vm._l(_vm.themes, function (theme, index) {
    var _theme$images, _theme$description, _theme$description$re;

    return _c('v-col', {
      key: index,
      staticClass: "py-3 py-md-0",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('v-layout', [_c('v-list-item', {
      staticClass: "border",
      attrs: {
        "ripple": false
      }
    }, [_c('v-list-item-icon', {
      staticClass: "elevation-3 radius-3 white"
    }, [theme !== null && theme !== void 0 && (_theme$images = theme.images) !== null && _theme$images !== void 0 && _theme$images[0] ? _c('v-img', {
      attrs: {
        "src": theme.images[0],
        "width": "256",
        "height": "192"
      }
    }) : _c('v-sheet', {
      attrs: {
        "width": "256",
        "height": "192"
      }
    })], 1), _c('v-list-item-content', {
      staticClass: "fill-height align-self-start px-2 py-4"
    }, [_c('v-responsive', {
      staticClass: "mb-auto"
    }, [_c('v-list-item-title', {
      staticClass: "d-flex",
      on: {
        "click": function click($event) {
          return _vm.details(theme);
        }
      }
    }, [_c('b', [_vm._v(_vm._s(theme.name))]), _c('v-spacer'), _c('v-icon', {
      staticClass: "mr-2",
      on: {
        "click": function click($event) {
          return _vm.details(theme);
        }
      }
    }, [_vm._v("mdi-cog")]), _c('v-icon', {
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.remove(theme);
        }
      }
    }, [_vm._v("mdi-delete")])], 1), _c('v-list-item-subtitle', [_c('p', {
      staticClass: "font-size-14 grey--text mt-1",
      domProps: {
        "innerHTML": _vm._s(theme === null || theme === void 0 ? void 0 : (_theme$description = theme.description) === null || _theme$description === void 0 ? void 0 : (_theme$description$re = _theme$description.replace) === null || _theme$description$re === void 0 ? void 0 : _theme$description$re.call(_theme$description, /\n/g, '<br>'))
      }
    })])], 1), _c('v-btn', {
      staticClass: "mt-auto",
      attrs: {
        "color": "primary"
      },
      on: {
        "click": function click($event) {
          return _vm.apply(theme);
        }
      }
    }, [_vm._v("적용")])], 1)], 1)], 1)], 1);
  }), 1)], 1), _c('v-pagination', {
    staticClass: "mt-3",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  }), _c('v-btn', {
    attrs: {
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "color": "accent"
    },
    on: {
      "click": _vm.create
    }
  }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }